import React from 'react';
import logo from '../LOGO_CONTROLLIMPIO.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'xxxxl';
  showTagline?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showTagline = true, className = '' }) => {
  // Usamos alturas fijas y ancho automático para mantener proporción
  const sizeClasses: Record<NonNullable<LogoProps['size']>, string> = {
    sm: 'h-8 w-auto',
    md: 'h-12 w-auto',
    lg: 'h-16 w-auto',
    xl: 'h-20 w-auto',
    xxl: 'h-24 w-auto',
    xxxl: 'h-32 w-auto',
    xxxxl: 'h-40 w-auto',
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logo}
        alt="Control Limpio"
        className={`${sizeClasses[size]} object-contain`}
      />
    </div>
  );
};

export default Logo;
